'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();var _desc,_value,_class;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const Formatters=require('../../../../../dist-es6/client/formatters');
const FatigueMeterType=require('../../../../../dist-es6/shared/domain/fatigueMeterType');
const BaseController=require('../../../../../dist-es6/client/angularCommon/baseController');
const SocketResponse=require('../../../../../dist-es6/client/dtos/socketResponse');
const EmiratesSearchType=require('../../../../../dist-es6/client/features/emirates/emiratesDashboard/domain/emiratesSearchType');
const{HandleUncaughtErrors:HandleUncaughtErrors}=require('../../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations;
const ErrorMessages=require('../../../../../dist-es6/client/errorMessages');

const{CrewRanksByType:CrewRanksByType}=require('../../../../../dist-es6/client/features/emirates/emiratesDashboard/components/crewRankSelectorDirective/crewRankSelectorDirective');let

EmiratesDashboardController=(_class=function(_BaseController){_inherits(EmiratesDashboardController,_BaseController);
function EmiratesDashboardController(
$scope,
$state,
$timeout,
$window,
$mdToast,
breadcrumbsService,
dateService,
timeZoneService,
emiratesSearchService,
scheduleRowScrollingService,
socketService,
uncaughtErrorHandler,
notificationService,
displaySettingsService){_classCallCheck(this,EmiratesDashboardController);var _this=_possibleConstructorReturn(this,

_BaseController.call(this,uncaughtErrorHandler,$timeout,$scope));

_this._$scope=$scope;
_this._$state=$state;
_this._$timeout=$timeout;
_this._$window=$window;
_this._$mdToast=$mdToast;
breadcrumbsService.startTrail('Dashboard');
_this._dateService=dateService;
_this._timeZoneService=timeZoneService;
_this._emiratesSearchService=emiratesSearchService;
_this._scheduleRowScrollingService=scheduleRowScrollingService;
_this._socketService=socketService;
_this._notificationService=notificationService;
_this._displaySettingsService=displaySettingsService;

_this.freshSearch=!0;
_this.showFullMenu=!0;

const debouncedUpdateSearchParameters=_.debounce(function(){
const selectedSearchType=_this.selectedSearchType;
const newParams={
pairing:_this.selectedPairing,
date:_this.selectedDate,
numDaysAvailable:_.exists(_this.numDaysAvailable)?parseInt(_this.numDaysAvailable,10):null,
timeOfDay:_this.timeOfDay,
staff:_this.selectedStaff,
activityCodes:_this.selectedDutyStatuses,
crewRank:_this.selectedRank,
fleets:CrewRanksByType.F.includes(_this.selectedRank)?_this.selectedFleets:[]};


if(_this._lastSearchType===selectedSearchType&&_.isEqual(_this._lastParams,newParams)){
return;
}

_this._lastParams=_.cloneDeep(newParams);
_this._lastSearchType=selectedSearchType;

_this._$timeout(function(){return _this._emiratesSearchService.updateSearchParameters(selectedSearchType,newParams)});
},150);

_this._$scope.$watchGroup([
'controller.selectedSearchType',
'controller.selectedPairing',
'controller.selectedDate',
'controller.selectedRank',
'controller.numDaysAvailable',
'controller.timeOfDay'],
function(){return debouncedUpdateSearchParameters()});

_this._$scope.$watchCollection('controller.selectedFleets',function(){return debouncedUpdateSearchParameters()});
_this._$scope.$watchCollection('controller.selectedDutyStatuses',function(){return debouncedUpdateSearchParameters()});
_this._$scope.$watchCollection('controller.selectedStaff',function(){return debouncedUpdateSearchParameters()});

_this.staffSearchAutoRefreshOn=_this._displaySettingsService.stickySettings.get('staffSearchAutoRefreshOn')||!1;
_this._$scope.$watch('controller.staffSearchAutoRefreshOn',function(newValue,oldValue){
if(newValue!==oldValue){
_this._displaySettingsService.stickySettings.set('staffSearchAutoRefreshOn',newValue);
}
});

_this.searchTypeOptions=EmiratesSearchType.All;
_this.selectedSearchType=_this.selectedSearchType||_this.searchTypeOptions[0];
_this.selectedDate=_this._dateService.now();

_this.openReport=function(){return _this._openReport()};

_this.searchTermSeparator=/[\s,]+/gi;
_this.autoRefreshFunc=function(){return _this.performSearch({isRefresh:!0,isAuto:!0})};return _this;
}EmiratesDashboardController.prototype.





performSearch=function(){var ref=_asyncToGenerator(function*(){let options=arguments.length>0&&arguments[0]!==void 0?arguments[0]:{};
if(!options.isRefresh){
this.freshSearch=!0;
}
try{
yield this._handledPerformSearch(options);
}catch(e){
if(!options.isAuto){
this._notificationService.displayNotification(ErrorMessages.OopsTryAgain,'error');
}
}
});function performSearch(){let options=arguments.length>0&&arguments[0]!==void 0?arguments[0]:{};return ref.apply(this,arguments)}return performSearch}();EmiratesDashboardController.prototype.

resyncMiniMode=function resyncMiniMode(){
if(this._emiratesSearchService.parametersForCurrentResults.type!==this.selectedSearchType){
this.selectedSearchType=this._emiratesSearchService.parametersForCurrentResults.type;
}
this.showFullMenu=!1;
};EmiratesDashboardController.prototype.


_handledPerformSearch=function(){var ref=_asyncToGenerator(function*(){var _this2=this;let options=arguments.length>0&&arguments[0]!==void 0?arguments[0]:{};
const searchResults=yield this._emiratesSearchService.performSearch(options);

if(searchResults==='NoResults'){
this._$mdToast.show(this._$mdToast.simple({
position:'top right',
template:
`<md-toast class="no-results">
<div class="md-toast-content">
	<strong>No results found.</strong>
	<span>There are no available crew members matching your search.</span>
</div>
</md-toast>`}));

return;
}

this._lastResultTime=this._dateService.now();

const{referenceScenario:referenceScenario,results:schedules,outputInterval:outputInterval}=searchResults;

this._$timeout(function(){
if(!_.exists(outputInterval)){
return;
}

_this2.showFullMenu=options.isRefresh?_this2.showFullMenu:!1;
_this2.referenceScenario=referenceScenario;
_this2.outputInterval=outputInterval;
_this2.schedules=schedules.map(function(s){return _.assign(s,{bounds:outputInterval})});

_this2.currentTopResultIndex=options.isRefresh?Math.min(_this2.currentTopResultIndex,Math.max(_this2.schedules.length-1,0)):0;
});
});function _handledPerformSearch(){let options=arguments.length>0&&arguments[0]!==void 0?arguments[0]:{};return ref.apply(this,arguments)}return _handledPerformSearch}();EmiratesDashboardController.prototype.

_openReport=function _openReport(){
let url=this._$state.href('fdc.features.emiratesReport',{
changeUserId:null,
date:this._dateService.now(),
timezone:this.localTimeZone});


this._$window.open(url,'_blank');
};_createClass(EmiratesDashboardController,[{key:'searchInProgress',get:function(){return this._emiratesSearchService.searchInProgress}},{key:'showBackButton',get:function()

{
return this._emiratesSearchService.hasPerformedSearch===!0;
}},{key:'readyToSearch',get:function()

{
return this._emiratesSearchService.readyToSearch;
}},{key:'isSameParametersAsLastSearch',get:function()

{
return this._emiratesSearchService.isSameParametersAsLastSearch;
}},{key:'localTimeZone',get:function()

{
return this._timeZoneService.localTimeZone;
}},{key:'lastResultTime',get:function()

{
return this._lastResultTime;
}},{key:'scheduleRowScrollClasses',get:function()

{
return this._scheduleRowScrollingService.scheduleScrollClasses;
}}]);return EmiratesDashboardController}(BaseController),(_applyDecoratedDescriptor(_class.prototype,'_handledPerformSearch',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_handledPerformSearch'),_class.prototype)),_class);




module.exports=EmiratesDashboardController;
//# sourceMappingURL=emiratesDashboardController.js.map
